import jquery from "jquery";
window.$ = window.jQuery = jquery;
import Flickity from 'flickity';

const selectors = {
  testimonialList: '.testimonial-list',
}


document.addEventListener("DOMContentLoaded", function () {
  const $carousel = $(selectors.testimonialList);
  if (!!$carousel.length) {
    var flkty = new Flickity( selectors.testimonialList, {
      percentPosition: true,
      contain: true,
      wrapAround: true,
      pageDots: true,
      resize: false,
      watchCSS: true,
      prevNextButtons: false,
    });
  }
});
// const $carousel = $(selectors.testimonialList);
// $carousel.on( 'ready.flickity', function() {
//   $(selectors.singleTestimonial).css("height", "100%");
// });



